var agi = agi || {};
agi.expressions = agi.expressions || {};

(function(Utils, ExpressEvent, EventDispatcher) {
    "use strict";
    /**
     * CanvasController manages canvas layer of video products.
     * It is responsible to set up canvas layer, routing
     * Express.X events to a proper handler.
     * It also handles events that related to the canvas layer.
     *
     * Future: should extends ExpressManager perhaps
     *
     * @class CanvasController
     * @extends EventDispatcher
     * @constructor
     * @param {Object} opts Options
     */
    var CanvasController = function(opts) {
        this.initialize(opts);
    };

    var p = CanvasController.prototype = new EventDispatcher();

    // Corresponds to Flash frames
    var START = 0;
    var PLAYING = 0;
    var END = 1;
    var BLANK = 0;
    var MOBILE_END = 2;
    var DURATION = 1;

    // public methods:
    /**
     * Initialization
     *
     * @param {Object} opts Options
     * @protected
     */
    p.initialize = function initialize(opts) {
        this.options = {
            env: {},
            product: {},
            containerId: 'expression-interactive-layer'
        };
        this.options = Utils.extend(this.options, opts);

        this.env = this.options.env;
        this.product = this.options.product;
        this.setup();
    };

    //Define where the create js content will live
    p.setup = function setup() {
        this.container = document.getElementById(this.options.containerId);
        this.canvas = document.getElementById("canvas");
        this.attachListeners();
    };

    //Listen for Expression events and handle them in handleEvent
    p.attachListeners = function attachListeners() {
        var Express = agi.expressions.Express;
        for(var key in Express) {
            if(typeof Express[key] == "function") {
                    Express.dispatcher.addEventListener(key, this);
            }
        }
        Express.dispatcher.addEventListener("expressionReady", this);
    };

    //Start createjs and load manifest
    p.ready = function ready() {
        //createjs images is a global variable
        //LoadQueue(preferXHR,basePath,crossOrigin)
        var queue = new createjs.LoadQueue(true, null, true);
        queue.installPlugin(createjs.Sound);
        queue.addEventListener("fileload", this);
        queue.addEventListener("complete", this);
        queue.addEventListener("error", this);

	    if(lib.properties.manifest.length > 0) {
            this.updateManifestUrls(lib.properties.manifest);
            queue.loadManifest(lib.properties.manifest);
        } else {
            this.assetsComplete();
        }
    };

    p.assetLoaded = function assetLoaded(event) {
        if(event.item.type === "image") {
            images[event.item.id] = event.result;
        }
    };

    p.assetsComplete = function assetsComplete(event) {
        //Set up the stage of create js content
        var className = "_" + this.env.productId;
	    this.root = new lib.card_html();
        this.stage = new createjs.Stage(this.canvas);
        this.stage.addChild(this.root);
        this.stage.update();
        this.stage.enableMouseOver();
        createjs.Touch.enable(this.stage, false, true);
        createjs.Ticker.setFPS(lib.properties.fps);
        createjs.Ticker.addEventListener("tick", this.stage);
        this.scaleContent();

	    //Add event listeners to Flash buttons
        this.root.playcardagainbutton.addEventListener("click", this.playAgain.bind(this));
        //If there is backstory, put an event listener on it
        if(this.root.backstoryplaycardagainbutton) {
            this.root.backstoryplaycardagainbutton.addEventListener("click", this.playAgain.bind(this));
        }
        //Same with share button
        if(this.root.shareplaycardagainbutton) {
            this.root.shareplaycardagainbutton.addEventListener("click", this.playAgain.bind(this));
        }
        

        // TODO to consider how the custom scrollbar and theme should be
        // added as a product option.
        $.mCustomScrollbar.defaults.scrollButtons.enable = false;
        $("#expression-user-message").mCustomScrollbar({autoHideScrollbar: false, theme: "minimal-custom-dark"})
        var event = new ExpressEvent("canvasReady");
        this.dispatchEvent(event);
    };

    //Trigger an event to play the video again, driven in JLVideo
    p.playAgain = function playAgain() {
        var event = new ExpressEvent("replay");
        this.dispatchEvent(event);
    };

    p.assetError = function assetError(event) {
        throw new Error(event.text);
    };

    //Get correct path
    p.updateManifestUrls = function updateManifestUrls(manifest) {
        for(var i = 0; i < manifest.length; i++) {
            var tempSrc = manifest[i]["src"];
            if (tempSrc.indexOf(this.env.imghost) == -1) {
                manifest[i]["src"] = this.env.imghost + this.env.contentMainPath + "/";
                manifest[i]["src"] += tempSrc;
            }
        }
    };

    p.scaleContent = function scaleContent() {
        if (this.stage != undefined) {
            //Set size of canvas
            this.canvas.width = 1024;
            this.canvas.height = 672;

            //Reset the values of inner container
            var innerContainer = document.getElementById("expression-inner-container");
            innerContainer.style.height = 672 + "px";
            innerContainer.style.width = 1024 + "px";

	        //Use the outer container to figure out what our current scale is
            var outerContainer = document.getElementById("expression-outer-container");
            var compStyleOut = getComputedStyle(outerContainer);
	        var w = parseFloat(compStyleOut.width);
            var scale = w / this.env.largeX;

            //Get the product container
	        var prodContainer = document.getElementById("product");
	        var compStyle = getComputedStyle(prodContainer);

            //Use the product container to see if we shoul;d scale by height instead
            if ((parseFloat(compStyle.height))/672 < scale) {
                scale = (parseFloat(compStyle.height)) / 672;
            }

	        //Make sure the scale does not exceed 1
            scale = (scale > 1) ? 1 : scale;
	    
            //Stage is 1024x672 to make the images crispy
            this.stage.width = 1024;
            this.stage.height = 672;
	    
            //Set the size of the parent container.  This determines our scale
            innerContainer.style.height = 672*scale + "px";
	        innerContainer.style.width = 1024*scale + "px";

            //Set the new scale to the interactive layer which contains the canvas
            var cardContainer = document.getElementById("expression-interactive-layer");
            cardContainer.style.width = 1024;
            cardContainer.style.height = 672;
            cardContainer.style.margin = "0 auto";
            cardContainer.style.transformOrigin = "top left";
            cardContainer.style.webkitTransformOrigin = "top left";
            cardContainer.style.transform = "scale("+scale+","+scale+")";
            cardContainer.style.webkitTransform = "scale("+scale+","+scale+")";
        }
    };

    //Handle Expression events
    p.handleEvent = function handleEvent(event) {
        switch (event.type) {
            case "expressionReady":
                this.ready();
                break;
            case "fileload":
                this.assetLoaded(event);
                break;
            case "complete":
                this.assetsComplete(event);
                break;
            case "error":
                this.assetError(event);
                break;
            case "showCanvas":
                this.showCanvas();
                break;
            case "hideCanvas":
                this.hideCanvas();
                break;
            default:
                this.dispatchEvent(event);
                break;
        };
    };

    //Check which end screen users will be sent to in create js content
    p.toWhatEnd = function toWhatEnd() {
        if (window.matchMedia('screen and (min-device-width : 300px) and (max-device-width : 667px)').matches) {
            return MOBILE_END;
        }
        else {
            return END;
        }
    }

    //Show the createjs content and go to proper frame
    p.showCanvas = function showCanvas() {
        this.container.style.display = "block";
        this.root.gotoAndStop(this.toWhatEnd());
    };

    //Hide the create js content
    p.hideCanvas = function hideCanvas() {
        this.container.style.display = "none";
        this.root.gotoAndStop(BLANK);
    };

    //Destroy the content, called from destroy in JLVideo
    p.destroy = function destroy() {
        var Express = agi.expressions.Express;
        for (var key in Express) {
            if (typeof Express[key] == "function") {
                var keyName = key;
                Express.dispatcher.removeEventListener(keyName, this);
            }
        }

        this.container = document.getElementById(this.options.containerId);
        if (this.container) {
            for (var i =0; this.container.children.length; i++) {
                this.container.removeChild(this.container.children[i])
            }
        }
    };

    agi.expressions.CanvasController = CanvasController;
})(agi.expressions.Utils, agi.expressions.ExpressEvent, createjs.EventDispatcher);
